var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('Bar'),_c('router-view'),_c('Place')],1)}
var staticRenderFns = []

export { render, staticRenderFns }